if (!customElements.get('jc-vigneron-filters')) {
  customElements.define(
    'jc-vigneron-filters',
    class JCVigneronFilters extends HTMLElement {
      static REVEAL_COUNT = 6;

      constructor() {
        super();
      }

      connectedCallback() {
        this.inputs = this.querySelectorAll('input[name="vigneron-region"]');
        this.items = this.querySelectorAll('.jc-vigneron-list__item');
        this.countEl = document.querySelector('.jc-vigneron-list__count');
        this.loadMoreWrap = this.querySelector('.jc-vigneron-list__load-more-wrap');
        this.loadMoreBtn = this.querySelector('.jc-vigneron-list__load-more');
        this.revealed = false;

        const activeRegion = new URLSearchParams(window.location.search).get('region') || '';
        this.inputs.forEach((input) => {
          input.checked = input.value === activeRegion;
        });
        if (![...this.inputs].some((input) => input.checked)) {
          const allInput = [...this.inputs].find((input) => input.value === '');
          if (allInput) allInput.checked = true;
        }

        this.handleChange = this.handleChange.bind(this);
        this.inputs.forEach((input) => input.addEventListener('change', this.handleChange));

        if (this.loadMoreBtn) {
          this.loadMoreBtn.addEventListener('click', () => {
            this.revealed = true;
            this.applyCap();
          });
        }

        this.applyFilters(false);
      }

      handleChange() {
        this.revealed = false;
        this.applyFilters(true);
      }

      applyFilters(updateUrl) {
        const activeInput = [...this.inputs].find((input) => input.checked);
        const activeRegion = activeInput ? activeInput.value : '';
        let visibleCount = 0;

        this.items.forEach((item) => {
          const visible = activeRegion === '' || item.dataset.region === activeRegion;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (this.countEl) {
          this.countEl.textContent = `${visibleCount} ${visibleCount === 1 ? 'vigneron' : 'vignerons'}`;
        }

        this.applyCap();

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (activeRegion) {
            url.searchParams.set('region', activeRegion);
          } else {
            url.searchParams.delete('region');
          }
          window.history.replaceState({}, '', url.toString());
        }
      }

      /* Caps the number of visible (post-filter) items to REVEAL_COUNT via
         [data-capped] — the CSS behind that attribute only hides items on
         mobile, so this is a no-op at desktop widths. "Charger plus"
         reveals the rest in one shot rather than paginating further, since
         every item is already in the DOM. */
      applyCap() {
        const visibleItems = [...this.items].filter((item) => !item.hidden);

        visibleItems.forEach((item, index) => {
          const capped = !this.revealed && index >= this.constructor.REVEAL_COUNT;
          item.toggleAttribute('data-capped', capped);
        });

        if (this.loadMoreWrap) {
          const hasMore = !this.revealed && visibleItems.length > this.constructor.REVEAL_COUNT;
          this.loadMoreWrap.hidden = !hasMore;
        }
      }
    }
  );
}
